import { createContext } from "react";
import { AsyncLoader } from "../../common-loader/hooks/useAsyncLoader";

export type LoaderContextAType<T> = {
  readonly loader: AsyncLoader<T>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LoaderContextA = createContext<LoaderContextAType<any> | null>(
  null
);
